import { useNavigate } from 'react-router-dom';
import { Star, Pencil, MapPin, User } from 'lucide-react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';

export function BranchCard({ branch, isAdmin }) {
  const navigate = useNavigate();

  const isDeleted = branch.deleted_at != null;
  const hasGeo = branch.latitude != null && branch.longitude != null;
  const cityDistrict = [branch.city, branch.district].filter(Boolean).join(', ');
  const geoPart = hasGeo
    ? `${Number(branch.latitude).toFixed(5)}, ${Number(branch.longitude).toFixed(5)}`
    : 'konum yok';
  const addressLine = cityDistrict ? `${cityDistrict} • ${geoPart}` : geoPart;

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-5 flex flex-col gap-3">
      <div className="flex items-center gap-2 flex-wrap">
        <h3 className="font-semibold text-slate-800">{branch.name}</h3>
        {branch.is_default && (
          <Badge className="bg-amber-100 text-amber-700">
            <Star size={11} /> Varsayılan
          </Badge>
        )}
        {isDeleted && <Badge className="bg-red-100 text-red-700">Silinmiş</Badge>}
        {branch.code && (
          <span className="text-xs text-slate-400 font-mono">{branch.code}</span>
        )}
      </div>

      <div className="space-y-1 text-sm text-slate-500">
        <p className="flex items-center gap-1.5">
          <MapPin size={13} className="shrink-0" /> {addressLine}
        </p>
        <p className="flex items-center gap-1.5">
          <User size={13} className="shrink-0" /> Yönetici: {branch.manager_name || '—'}
        </p>
      </div>

      <div className="flex justify-end gap-2 pt-1">
        <Button variant="secondary" size="sm" onClick={() => navigate(`/settings/branches/${branch.id}`)}>
          Detay
        </Button>
        {/* Silinmiş şube düzenlenemez → [Düzenle] yalnız aktif şubede + admin */}
        {isAdmin && !isDeleted && (
          <Button variant="ghost" size="sm" onClick={() => navigate(`/settings/branches/${branch.id}/edit`)}>
            <Pencil size={14} /> Düzenle
          </Button>
        )}
      </div>
    </div>
  );
}
